module.exports = __webpack_public_path__ + "img/new-tab.991a9eaa.svg";